import { render, staticRenderFns } from "./UserSalary.vue?vue&type=template&id=135e643c&"
import script from "./UserSalary.vue?vue&type=script&lang=js&"
export * from "./UserSalary.vue?vue&type=script&lang=js&"
import style0 from "./UserSalary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports